var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VTRichTextEditorContentPreview } from "../VTRichTextEditor/VTRichTextEditorContentPreview";
import { Box, IconButton, Tooltip } from "@mui/material";
import { VTHTMLSVGIcon } from "../VTHTMLSVGIcon";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import textCutOffAddElipsis from "../../utils/textCutOffAddElipsis";
import { forwardRef } from "react";
import VTHotspotContentViewer2 from "../VTHotspotContentCreator/VTHotspotContentViewer2";
function iconSwitchGetSvg(icon) {
    switch (icon) {
        case "info":
            return _jsx(VTHTMLSVGIcon, { svgIconUrl: "".concat(process.env.PUBLIC_URL, "/icons/info.svg") });
        case "arrow":
            return _jsx(VTHTMLSVGIcon, { svgIconUrl: "".concat(process.env.PUBLIC_URL, "/icons/movement.svg") });
        case "movement":
            return _jsx(VTHTMLSVGIcon, { svgIconUrl: "".concat(process.env.PUBLIC_URL, "/icons/movementCircles.svg") });
    }
}
var textCutOffPointAtChar = 54;
var CloseButton = function (_a) {
    var onClose = _a.onClose;
    return (_jsx(IconButton, __assign({ onClick: onClose, sx: {
            position: "absolute",
            right: "-22px",
            top: "-10px",
            width: "23px",
            height: "23px",
            background: "rgba(48, 48, 48, 0.5)",
            color: "#fff",
            "&:hover": {
                background: "rgba(48, 48, 48, 0.4)",
            },
        } }, { children: _jsx(CloseRoundedIcon, { sx: { fontSize: "0.8em" } }) })));
};
export var VTHTMLHotspot = forwardRef(function (_a, ref) {
    var title = _a.title, icon = _a.icon, vtRichTextEditorContent = _a.vtRichTextEditorContent, onClick = _a.onClick, onClose = _a.onClose, onHover = _a.onHover, _b = _a.scale2d, scale2d = _b === void 0 ? 1 : _b, sx = _a.sx;
    return (_jsxs(Box, __assign({ ref: ref, component: "div", sx: __assign({ transform: "scale(".concat(scale2d, ")"), display: "inline-flex", alignItems: "center", flexDirection: "column" }, sx) }, { children: [(title || icon) && (_jsxs(Box, __assign({ component: "div", sx: {
                    maxWidth: "300px",
                    position: "relative",
                    marginBottom: "-5px",
                } }, { children: [onClose && title && _jsx(CloseButton, { onClose: onClose }), _jsx(Tooltip, __assign({ disableHoverListener: !Boolean(title && title.length > textCutOffPointAtChar), title: title, arrow: true, placement: "bottom" }, { children: _jsxs(Box, __assign({ component: "div", sx: {
                                width: "100%",
                                background: "rgba(48, 48, 48, 0.5);",
                                padding: "10px",
                                borderRadius: "15px",
                                cursor: "pointer",
                                textAlign: "center",
                            }, onClick: onClick, onMouseOver: function () { return onHover && onHover(true); }, onMouseLeave: function () { return onHover && onHover(false); } }, { children: [icon && (_jsx("div", __assign({ style: {
                                        display: "inline-block",
                                        height: "100px",
                                        width: "100px",
                                    } }, { children: iconSwitchGetSvg(icon) }))), title && (_jsx("h3", __assign({ style: { margin: "0px", lineHeight: "1.1em" } }, { children: textCutOffAddElipsis(title, textCutOffPointAtChar) })))] })) }))] }))), Array.isArray(vtRichTextEditorContent === null || vtRichTextEditorContent === void 0 ? void 0 : vtRichTextEditorContent.content) && (_jsxs(Box, __assign({ component: "div", sx: {
                    position: "relative",
                    cursor: "pointer",
                    paddingTop: vtRichTextEditorContent ? "10px" : "0px",
                    borderRadius: "0px 0px 15px 15px",
                }, onMouseOver: function () { return onHover && onHover(true); }, onMouseLeave: function () { return onHover && onHover(false); } }, { children: [onClose && !(title || icon) && _jsx(CloseButton, { onClose: onClose }), _jsx(VTHotspotContentViewer2, { onClick: onClick, sx: {
                            width: "".concat(vtRichTextEditorContent.width, "px"),
                            height: "".concat(vtRichTextEditorContent.height, "px"),
                            overflowY: "auto",
                            overflowX: "clip",
                            background: "rgba(48, 48, 48, 0.5);",
                            padding: "10px",
                            borderRadius: "15px",
                        }, data: vtRichTextEditorContent.content })] }))), typeof (vtRichTextEditorContent === null || vtRichTextEditorContent === void 0 ? void 0 : vtRichTextEditorContent.content) === "string" && (_jsxs(Box, __assign({ component: "div", sx: {
                    position: "relative",
                    cursor: "pointer",
                    paddingTop: vtRichTextEditorContent ? "10px" : "0px",
                    borderRadius: "0px 0px 15px 15px",
                }, onMouseOver: function () { return onHover && onHover(true); }, onMouseLeave: function () { return onHover && onHover(false); } }, { children: [onClose && !(title || icon) && _jsx(CloseButton, { onClose: onClose }), _jsx(VTRichTextEditorContentPreview, { onClick: onClick, sx: __assign(__assign(__assign({}, (!vtRichTextEditorContent.width
                            ? { maxWidth: "480px" }
                            : {
                                width: "".concat(vtRichTextEditorContent.width, "px"),
                            })), (!vtRichTextEditorContent.height
                            ? { maxHeight: "300px" }
                            : {
                                height: "".concat(vtRichTextEditorContent.height, "px"),
                            })), { overflowY: "auto", overflowX: "clip", background: "rgba(48, 48, 48, 0.5);", padding: "10px", borderRadius: "15px" }), htmlContent: vtRichTextEditorContent.content })] })))] })));
});
